import React from 'react';
import { useObservable } from 'react-use-observable';

import { Col, Form, Row, Select, Typography } from 'antd';

import useGetAllowedEmailsExport from 'v2/hooks/useGetAllowedEmailsExport';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import ExportWarning from '../../ExportWarning';

interface IProps {
  success: boolean;
  sentEmail: string;
  message: string;
}

const DEFAULT_MESSAGE =
  'O relatório solicitado é muito grande para te entregarmos agora, mas fique tranquilo estamos gerando ele com cuidado e iremos enviar em seu email assim que estiver pronto!';

export const Content = ({ success, sentEmail, message = DEFAULT_MESSAGE }: IProps) => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const { isLoading, data: emailsAllowedExport } = useGetAllowedEmailsExport();
  const emailsAllowedExportFormatted = emailsAllowedExport.sort().map(email => ({
    label: email,
    value: email
  }));

  return (
    <div className='py-4'>
      {success ? (
        <Typography.Paragraph>
          Geração do relatório solicitada com sucesso, você irá receber o relatório no e-mail{' '}
          <Typography.Text strong>{sentEmail || user?.email}</Typography.Text> quando o processo finalizar.
        </Typography.Paragraph>
      ) : (
        <Row gutter={[16, 16]}>
          {message && (
            <Col span={24}>
              <ExportWarning />
              <Typography.Paragraph>{message}</Typography.Paragraph>
            </Col>
          )}
          <Col span={24}>
            <Form.Item label='E-mail'>
              <Select
                id='email'
                placeholder={user?.email}
                disabled={isLoading}
                options={emailsAllowedExportFormatted}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </div>
  );
};
